/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/button-has-type */
import { Box, H3 } from '@ouster/webviz-react-components';

import { useNavigate } from 'react-router-dom';

import styles from './UserOrgSwitch.module.css';
import { useStoreState, useStoreActions } from '../../reducers';

const OrgTag = ({
  orgName,
  id,
  curOrgId,
  handleSwitchAccount,
}: {
  orgName: string;
  id: number;
  curOrgId: number;
  handleSwitchAccount: (id: number) => void;
}) => {
  const isActive = id === curOrgId;

  return (
    <button
      className={`${styles.tag} ${isActive && styles.active}`}
      onClick={() => handleSwitchAccount(id)}
      data-testid={`user-org-switch-btn-${id}`}
    >
      {orgName} {isActive && <span>(current)</span>}
    </button>
  );
};

export default function UserOrgSwitch({
  closeUserMenu,
}: {
  closeUserMenu: () => void;
}) {
  const { curUserOrg, userOrgs } = useStoreState(
    (storeState) => storeState.user
  );

  const { setCurUserOrg } = useStoreActions((actions) => actions.user);

  const navigate = useNavigate();

  function handleSwitchAccount(id: number) {
    setCurUserOrg(id);
    sessionStorage.setItem('orgChanged', 'true');
    sessionStorage.setItem('columnVisibilityChanged', 'true');

    // If user tries to switch to a different organization while in a drive visualization,
    // redirect them to that org's private drive page.
    const currentPath = window.location.pathname;
    const driveVizRegex = /\/organization\/\d+\/drive\/\d+/;
    if (driveVizRegex.test(currentPath)) {
      navigate('/drive/private');
    }

    closeUserMenu();
  }

  if (!curUserOrg) return null;

  return (
    <Box paddingBlock="0.75rem" paddingInline="1.25rem" fontSize={14} data-testid="user-org-switch-root">
      <H3 fontSize={14}>User organizations</H3>
      <Box mt={6} display="grid" rowGap={4} maxH={300} overflowY="auto">
        <OrgTag
          key={curUserOrg.id}
          orgName={curUserOrg.name}
          id={curUserOrg.id}
          curOrgId={curUserOrg.id}
          handleSwitchAccount={handleSwitchAccount}
        />
        {userOrgs
          .filter((org) => org.id !== curUserOrg.id)
          .map((org) => (
            <OrgTag
              key={org.id}
              orgName={org.name}
              id={org.id}
              curOrgId={curUserOrg.id}
              handleSwitchAccount={handleSwitchAccount}
            />
          ))}
      </Box>
    </Box>
  );
}
